import React, { useEffect, useState, useRef  } from 'react';
import { useNavigate } from 'react-router-dom';
// import longTournamentSocket from './longTournamentSocket';
import KnockoutScoreboard from './KnockoutScoreboard';
import SpinWheelOverlay from './SpinWheelOverlay';
import longTournamentSocket, { ensureLongSocket } from './longTournamentSocket';
import TournamentPaymentModal from './components/TournamentPaymentModal';
import { useSound } from './sfx/SoundProvider'; // ← добавь

import axios from 'axios';

function LongTournamentLobby({ username,typeGame }) {
  const navigate = useNavigate();
  const [tournaments, setTournaments] = useState([]);
  const [showBracketForId, setShowBracketForId] = useState(null);
  const [wheelData, setWheelData] = useState(null);
  const [showWheel, setShowWheel] = useState(false);
  const connectRef = useRef(null); // 👈 добавь
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [selectedTournament, setSelectedTournament] = useState(null);
  const [leavingId, setLeavingId] = useState(null); // id турнира, где идёт «отмена»
  const { play } = useSound();   


useEffect(() => {
  if (!username) return;
  ensureLongSocket(username);

  // 1. Слушаем персональные приглашения
  const onTable = ({ tableId }) => {
    console.log('[CLIENT] Получил long_tournamentTable → открываю стол', tableId);
    navigate(`/long-tournament/table?tableId=${tableId}`);
  };
  longTournamentSocket.on('long_tournamentTable', onTable);

  // 2. Функция для ручной проверки
  const checkActiveMatch = () => {
    longTournamentSocket.emit('long_getMyActiveTable', (resp) => {
      console.log('[CLIENT] Ответ на long_getMyActiveTable:', resp);
      if (resp?.tableId) {
        navigate(`/long-tournament/table?tableId=${resp.tableId}`);
      }
    });
  };

  // 3. Гарантированно вызываем
  if (longTournamentSocket.connected) {
    checkActiveMatch();
  } else {
    longTournamentSocket.once('connect', checkActiveMatch);
  }

  return () => {
    longTournamentSocket.off('long_tournamentTable', onTable);
    longTournamentSocket.off('connect', checkActiveMatch); // ❗ важно!
  };
}, [username, navigate]);


// LongTournamentLobby.jsx
// useEffect(() => {
//   if (!username) return;
//   ensureLongSocket(username);

//  /* 1.  Слушаем персональное приглашение на полуфинальный / финальный стол */
//  const onTable = ({ tableId }) => {
//    console.log('[CLIENT] Получил long_tournamentTable → открываю стол', tableId);
//    navigate(`/long-tournament/table?tableId=${tableId}`);
//  };
//  longTournamentSocket.on('long_tournamentTable', onTable);

//   /* 2.  Периодически опрашиваем «а нет ли у меня уже стола?»  */
//  const askActive = () =>
//    longTournamentSocket.emit('long_getMyActiveTable', (resp) => {
//      if (resp?.tableId) navigate(`/long-tournament/table?tableId=${resp.tableId}`);
//    });

//  askActive();                        // сразу
//  const pollId = setInterval(askActive, 5_000); // и каждые 5 с (по желанию)

//   /* 3.  Старые обработчики (requestAllTournaments и пр.) */
  
//   return () => {
//    longTournamentSocket.off('long_tournamentTable', onTable);
//    clearInterval(pollId);
    
//   };
// }, [username, navigate]);

useEffect(() => {
  const ask = () => {
    console.log('[CLIENT] отправляем requestAllTournaments (LONG)');
    longTournamentSocket.emit('requestAllTournaments');
  };

  connectRef.current = ask;

  longTournamentSocket.on('connect', ask);
  if (longTournamentSocket.connected) ask();

    const handle = (all) => {
    const order = { registration: 0, creating_semifinal: 1, semifinal: 1, creating_final: 2, final: 2 };
    const active = all
    .filter(t => t.status !== 'finished' && t.gameType === 'long')
    .sort((a, b) => {
      const sa = order[a.status] ?? 99;
      const sb = order[b.status] ?? 99;
      if (sa !== sb) return sa - sb;
      return (b.id || 0) - (a.id || 0);
    });

   // ✅ нормализуем buyIn в одно поле и приводим к числу
    setTournaments(
      active.map(t => ({
        ...t,
        buyIn: Number(t.buyIn ?? t.buy_in ?? 0),
      }))
    );
};


  longTournamentSocket.on('responseAllTournaments', handle);

  const onCount = ({ tournamentId, count, max }) => {
    setTournaments(prev =>
      prev.map(tt => tt.id === tournamentId ? { ...tt, registeredCount: count, maxPlayers: max } : tt)
    );
  };
  longTournamentSocket.on('tournament_registeredCount', onCount);
  return () => {
    longTournamentSocket.off('connect', connectRef.current);
    longTournamentSocket.off('responseAllTournaments', handle);
    longTournamentSocket.off('tournament_registeredCount', onCount);
  };
}, [username, navigate]);








useEffect(() => {
  function onJoined({ tournamentId, player }) {
    setTournaments(prev =>
      prev.map(t =>
        t.id === tournamentId
          ? {
              ...t,
              registeredPlayers: [...(t.registeredPlayers || []), player],
              registeredCount: (t.registeredCount || 0) + 1,
            }
          : t
      )
    );
  }

  longTournamentSocket.on('tournament_joined', onJoined);
  return () => longTournamentSocket.off('tournament_joined', onJoined);
}, []);


//До спама
// useEffect(() => {
//   const ask = () => longTournamentSocket.emit('requestAllTournaments');

//   if (longTournamentSocket.connected) {
//     ask(); // если уже подключён — сразу спрашиваем
//   } else {
//     longTournamentSocket.once('connect', ask); // иначе ждём подключения
//   }

//   const handle = (all) => {
//     console.log('[CLIENT] Получены турниры по длинным:', all);
//     const active = all.filter(t => t.status !== 'finished');
//     setTournaments(active);
//   };

//   longTournamentSocket.on('responseAllTournaments', handle);

//   return () => {
//     longTournamentSocket.off('connect', ask);
//     longTournamentSocket.off('responseAllTournaments', handle);
//   };
// }, []);

// useEffect(() => {
//   const ask = () => longTournamentSocket.emit('requestAllTournaments');

//   if (longTournamentSocket.connected) {
//     ask(); // если уже подключён — сразу спрашиваем
//   } else {
//     longTournamentSocket.once('connect', ask); // иначе ждём подключения
//   }

//   const handle = (all) => {
//     console.log('[CLIENT] Получены турниры по длинным:', all);
//     const active = all.filter(t => t.status !== 'finished');
//     setTournaments(active);
//   };

//   longTournamentSocket.on('responseAllTournaments', handle);

//   return () => {
//     longTournamentSocket.off('connect', ask);
//     longTournamentSocket.off('responseAllTournaments', handle);
//   };
// }, []);


// useEffect(() => {
//   const handleTournaments = (all) => {
//     console.log('[CLIENT] Получены турниры по длинным:', all);
//     const active = all.filter(t => t.status !== 'finished');
//     setTournaments(active);
//   };

//   longTournamentSocket.on('responseAllTournaments', handleTournaments);
//   return () => {
//     longTournamentSocket.off('responseAllTournaments', handleTournaments);
//   };
// }, []);










// useEffect(() => {
//   longTournamentSocket.on('responseAllTournaments', (data) => {
   
//     setTournaments(data);
//   });
// }, []);



  // useEffect(() => {
  //   if (!longTournamentSocket.connected) {
  //     longTournamentSocket.connect();
  //   }
  //   longTournamentSocket.emit('requestAllTournaments');
  // }, []);

  // useEffect(() => {
  //   const handleTournaments = (all) => {
  //     const active = all.filter((t) => t.status !== 'finished');
  //     setTournaments(active);
  //   };

  //   longTournamentSocket.on('responseAllTournaments', handleTournaments);
  //   return () => longTournamentSocket.off('responseAllTournaments', handleTournaments);
  // }, []);

  useEffect(() => {
    longTournamentSocket.on('spinWheel', ({ angle, prize, buyIn }) => {
      setWheelData({ angle, prize, buyIn });
      setShowWheel(true);
    });

    return () => longTournamentSocket.off('spinWheel');
  }, []);

  useEffect(() => {
    longTournamentSocket.on('tournament_semifinalsStarted', ({ tournamentId, semifinalTables }) => {
      const found = semifinalTables.find(
        (m) => m.player1 === username || m.player2 === username
      );
      if (found) {
          console.log('[CLIENT] Меня вызывают в игру:', found);
        navigate(`/longTournamentMatch/${found.gameId}?tableId=${found.tableId}`);
      }
    });

    longTournamentSocket.on('tournament_finalStarted', ({ finalGameId, finalTableId, player1, player2 }) => {
      if (player1 === username || player2 === username) {
        navigate(`/longTournamentMatch/${finalGameId}?tableId=${finalTableId}`);
      }
    });

    return () => {
      longTournamentSocket.off('tournament_semifinalsStarted');
      longTournamentSocket.off('tournament_finalStarted');
    };
  }, [username, navigate]);



useEffect(() => {
  function handleFinalStarted({ tournamentId, finalTableId, finalGameId, player1, player2 }) {
    console.log('[CLIENT] long_tournament_finalStarted:', { finalGameId, finalTableId });

    if (player1 === username || player2 === username) {
      navigate(`/longTournamentMatch/${finalGameId}?tableId=${finalTableId}`);
    }
  }

  longTournamentSocket.on('long_tournament_finalStarted', handleFinalStarted);

  return () => {
    longTournamentSocket.off('long_tournament_finalStarted', handleFinalStarted);
  };
}, [username, navigate]);


// 🔔 Мгновенное появление карточки нового турнира (аналогичного) после финала
useEffect(() => {
  function onCreated(t) {
    // Бережно: показываем только длинные турниры + без дублей
    if (!t || t.gameType !== 'long') return;
    setTournaments(prev => {
      // если уже есть — не добавляем
      if (prev.some(x => x.id === t.id)) return prev;
      // Добавляем сверху. Рендер у тебя и так .slice(0,4)
      return [t, ...prev];
    });
  }

  longTournamentSocket.on('tournament_created', onCreated);
  return () => {
    longTournamentSocket.off('tournament_created', onCreated);
  };
}, [setTournaments]);



const handlePaymentClose = () => {
  setShowPaymentModal(false);
  setSelectedTournament(null);
};

  // const handleJoinTournament = (t) => {
  //   if (!username) return alert('Сначала авторизуйтесь!');
  //   const yes = window.confirm(`Регистрация в турнире buyIn=$${t.buyIn}?`);
  //   if (!yes) return;
  //   console.log('23424234',{
  //     tournamentId: t.id,
  //     userName: username,
  //   });
    
  //   longTournamentSocket.emit('tournament_joinTournament', {
  //     tournamentId: t.id,
  //     userName: username,
  //   });
  // };


  const handleJoinTournament = (t) => {
  if (!username) return alert('Сначала авторизуйтесь!');
  setSelectedTournament({ ...t, buyIn: Number(t.buyIn ?? t.buy_in ?? 0), gameType: 'long' });
  play('registerTournament').catch(() => {});
  setShowPaymentModal(true);
};

//  const handleJoinTournament = (t) => {
//   if (!username) return alert('Сначала авторизуйтесь!');
//   setSelectedTournament({ ...t, gameType: 'long' }); // ← важно
//   setShowPaymentModal(true);
// };


const handleLeaveTournament = (t) => {
   if (!username) return alert('Сначала авторизуйтесь!');
  if (!window.confirm('Отменить регистрацию и вернуть взнос?')) return;
  setLeavingId(t.id);
  longTournamentSocket.emit(
    'tournament_leaveTournament',
    { tournamentId: t.id, userName: username, gameType: 'long' },
    (resp) => {
      setLeavingId(null);
      if (!resp?.ok) {
        alert(resp?.error || 'Ошибка при отмене');
       return;
      }
      // Можно принудительно запросить список, но обычно придёт broadcast:
      // longTournamentSocket.emit('requestAllTournaments');
    }
  );
};
  // const handleLeaveTournament = (t) => {
  //   if (!username) return alert('Сначала авторизуйтесь!');
  //   const yes = window.confirm('Отменить регистрацию?');
  //   if (!yes) return;
  //   longTournamentSocket.emit('tournament_leaveTournament', {
  //     tournamentId: t.id,
  //     userName: username,
  //   });
  // };

  // if (typeGame !== 1) return null;
 
  return (
    <div style={{ margin: 20 }}>
 {selectedTournament && (
  <TournamentPaymentModal
    open={showPaymentModal}
    tournament={selectedTournament}
    apiBase="/api/long-tournament"
    onClose={handlePaymentClose}
    onSuccess={(method) => {
      longTournamentSocket.emit('tournament_joinTournament', {
        tournamentId: selectedTournament.id,
        userName: username,
        gameType: 'long',
        method,
      });
      handlePaymentClose();
    }}
  />
)}


      {showWheel && wheelData && (
        <SpinWheelOverlay
          angle={wheelData.angle}
          prize={wheelData.prize}
          buyIn={wheelData.buyIn}
          onClose={() => setShowWheel(false)}
        />
      )}


         
                </div>
            
  );
}

export default LongTournamentLobby;
